
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title"><span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Slideout_Section_Title">Display</span></div>
    <div class="custom-setting-section-context">
        <span style="margin-right: 3px;">{{ enabledSettings }}/{{ settings.all.length }}</span>
        <span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Slideout_Context_Count">states selected</span>
    </div>
    <div class="custom-setting-section-body">
        <div class="container no-gutters p-0 currentAgentStatesSlideoutSettings">
            <div class="row mb-3">
                <div class="col">
                    <div class="search-box live-search">
                        <input type="search" class="form-control form-control-lg" cvLocalizedPlaceholder langSection="Common" langKey="Search" placeholder='Search' [(ngModel)]="stateNameFilter" />
                        <span class="clear-input" [hidden]="!(stateNameFilter.length > 0)" (click)="stateNameFilter = ''"></span>
                     </div>
                </div>
            </div>
            <div class="row no-gutters" *ngIf="!dataLoading && showSourceRadio">
                <div class="col">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="showAssignedSkillsCheck" [(ngModel)]="showAssignedSkills"/>
                        <label class="form-check-label" for="showAssignedSkillsCheck" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Skill_Config_All_Assigned">Show all assigned skills, when possible</label>
                    </div>
                    <hr/>
                </div>
            </div>
            <!-- State Setttings.  Custom spacing, instead of continuing with Bootstrap Grid:  -->
            <div class="row no-gutters" *ngIf="!dataLoading">
                <div class="col d-flex flex-column agent-state-settings px-2">
                    <!-- State Rows:  -->
                    <!-- Hard-coded states first, "belongsLeft" from the legacy settings, then the Distinct Agent States:  -->
                    <!-- The filter in ng-repeat is used for the search functionality. -->
                    <div class="state-row pb-2" *ngFor="let state of (statesInDisplayOrder | filterText: stateNameFilter : 'StateDisplayName'); let $index = index" [class.pt-3]="!($index === 0)">
                        <div class="w-100 d-flex flex-nowrap align-items-center">
                            <div class="controls-group d-flex flex-nowrap h-100 align-items-center">
                                <input type="checkbox" class="form-check-input m-0 p-0 d-block" id="{{'state-' + $index}}" [(ngModel)]="state.enabled" (ngModelChange)="stateChanged()" title="{{ localizations?.get(state.StateDisplayName) ?? state.StateDisplayName }}" />
                                <div class="state-circle-container" 
                                    [class.clickable]="isStateCustom(state)" 
                                    (click)="showColorModal(state)" 
                                    [attr.title]="isStateCustom(state) ? colorModalTitle : undefined">
                                
                                    <div class="d-block state-circle" [ngStyle]="{'background-color': state.Color}"></div>
                                    <img *ngIf="isStateCustom(state)" class="eye-dropper" src='../../App_Themes/clearview-default/images/eye-dropper.svg'/>
                                </div>
                            </div>
                            <div class="state-name h-100">
                                <label class="form-check-label body-2 lato-bold d-block text-truncate" for="{{'state-' + $index}}" title="{{ localizations?.get(state.StateDisplayName) ?? state.StateDisplayName }}">
                                    {{ localizations?.get(state.StateDisplayName) ?? state.StateDisplayName }}
                                </label>
                            </div>
                        </div>
                        <div class="d-flex flex-nowrap mt-2">
                            <div class="min-max d-flex flex-nowrap align-items-center">
                                <label for="{{'min-' + $index}}" class="form-control-label body-2 m-0 mr-1"><span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Min">Min</span></label>
                                <input id="{{'min-' + $index}}" [cleave]="cleaveSettings" placeholder="00:00:00" maxlength="8" class="form-control form-control-sm" style="min-width: 0;" [ngClass]="['inputMin' + validateNameForCleave(state)]" [(ngModel)]="state.rawMin" />
                            </div>
                            <div class="min-max d-flex flex-nowrap align-items-center ml-3">
                                <label for="{{'max-' + $index}}" class="form-control-label body-2 m-0 mr-1"><span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Max">Max</span></label>
                                <input id="{{'max-' + $index}}" [cleave]="cleaveSettings" placeholder="00:00:00" maxlength="8" class="form-control form-control-sm" style="min-width: 0;" [ngClass]="['inputMax' + validateNameForCleave(state)]" [(ngModel)]="state.rawMax" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="dataLoading">
                <div class="col position-relative" style="height: 200px; width: 200px;">
                    <cv-loader size="large" [overlay]="false" class="d-block"></cv-loader>
                </div>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>

<cv-module-custom-setting-section class="d-flex ml-3 pl-1" *ngIf="navigationService.companyPartner === 8 && moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager" inside="emp">
    <div class="custom-setting-section-inside-body ml-2 pl-1">
        <div class="body-2 color-whaleTail mb-1">Teams</div>
        <cv-single-attribute-selector *ngIf="moduleManager.container.settingsOpen" class="d-flex" attributeName="Teams" [attributeType]="1" [pageName]="moduleManager.getModuleKey() + '_temp'" [autoWidth]="false"></cv-single-attribute-selector>
    </div>
</cv-module-custom-setting-section>

<!-- Slideout PM metric selector section -->
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager" [after]="metricSelectorPlacement">
    <div class="custom-setting-section-title">
        <span cvLocalizedText langSection="Current_Agent_States_Module" langKey="Metrics">Metrics</span>
    </div>
    <div class="custom-setting-section-context"> {{ getSlideoutContextSectionText(settings.useMetrics) }} </div>
    <div class="custom-setting-section-body">
        <div class="d-flex flex-nowrap align-items-center">
            <mat-slide-toggle [(ngModel)]="settings.useMetrics" (ngModelChange)="handleUseMetricsChange()" class="mr-2">
                <mat-label class="body-2" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Show_Metric_Data">Show Metric Data</mat-label>
            </mat-slide-toggle>
            <div style="fill:#A8AFB9" data-bs-toggle="tooltip" data-html="true" [title]="tooltipContexMetricstData">
                <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use></svg>
            </div>  
        </div>
        <div class="d-flex flex-nowrap align-items-start mt-2">
            <button type="button"
                [disabled]="!settings.useMetrics"
                class="btn btn-primary"
                (click)="openMetricSelector()"
                cvLocalizedText langSection="Current_Agent_States_Module" langKey="Metrics">Metrics</button>
        </div>
        <div class="row" *ngIf="settings.useMetrics">
            <div class="col-12">
                <div class="d-flex flex-wrap">
                    <div class="rounded-pill settings-hover-colors d-flex cursor-pointer mt-3 py-1 px-3 mr-2" *ngFor="let metric of settings.selectedMetrics" [attr.title]="metric.Name" style="height: 24px;">
                        <div class="flex-fill my-auto" style="line-height: 1rem;"><span>{{ getMetricDisplayName(metric) }}</span></div>
                        <svg [attr.id]="('module-' + stateKey + '-Settings-metric-' + metric.Abbreviation + '-' + metric.Id) | cleanId" class="icon-16 fill-valyrianSteel fill-hover-whaleTail my-auto ml-2" (click)="removeMetric(metric.Id)" style="height: 12px; width: 12px;">
                            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
<div cvModuleLegacyCustomSettingSection class="currentAgentStateSettings" position="bottom" [moduleManager]="moduleManager">
    <div class="advancedSettingsToggle" (click)="toggleVisible()">
        <div class="advancedSettingsTitle" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Advanced_Settings">Advanced Settings</div>
        <div class="pointerArrow" [class.rotate]="openSettings" ></div>
    </div>
    <div [ngSwitch]="dataLoading" class="statesSettingsContainer" [ngClass]="openSettings ? 'show'  : 'hide'">
        <div class="loading-holder position-relative mx-auto" style="width: 100px; height: 100px;" *ngSwitchCase="true">
            <cv-loader [overlay]="false"></cv-loader>
        </div>
        <div *ngSwitchDefault>
            <div class="sourceColumnConfig mb-3" *ngIf="showSourceRadio">
                <h5 class="sectionHeader font-size-18">
                    Source column values
                </h5>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="showAssignedSkillsCheck" [(ngModel)]="showAssignedSkills"/>
                    <label class="form-check-label" for="showAssignedSkillsCheck" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Skill_Config_All_Assigned">Show all assigned skills, when possible</label>
                </div>
            </div>
            <h5 class="sectionHeader font-size-18">
                Agent States
            </h5>
            <div class="statesConfig">
                <!-- Left Column -->
                <div class="statesColumn">
                    <div class="agentStateSettingGroup stateinputsTitleGroup" style="margin-bottom: 12px;">
                        <div class="stateInputsGroup">
                            <div class="stateGroupLeft">
                            </div>
                            <div class="stateGroupRight">
                                <div class="stateGroupTitle" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Min">Min</div>
                                <div class="stateGroupTitle" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Max">Max</div>
                            </div>
                        </div>
                    </div>
                    <!-- Left side is populated by those states which belongsLeft == true.  Sorts by EState value -->
                    <!-- make a belongs left settings array and update any time settings.all changes FIXME check to see if works-->
                    <div class="agentStateSettingGroup" *ngFor="let state of settings.filteredLeft; let $index = index">
                        <div class="stateInputsGroup">
                            <div class="stateGroupLeft">
                                <input id="{{moduleKey + '-left-' + $index}}" type="checkbox" class="sgCustomCheckbox" [(ngModel)]="state.enabled" />
                                <div class="colorCircle" [ngStyle]="{ 'background-color': state.Color }"></div>
                                <!-- {{ service.AgentStatesMessages[state.StateDisplayName] != null ? service.AgentStatesMessages[state.StateDisplayName][0] : state.StateDisplayName }} -->
                                <label for="{{moduleKey + '-left-' + $index}}" 
                                    class="stateTitle textTruncate" 
                                    title="{{ state.StateDisplayName }}">
                                    {{ localizations?.get(state.StateDisplayName) ?? state.StateDisplayName }}
                                </label>
                            </div>
                            <div class="stateGroupRight">
                                <input [cleave]="cleaveSettings" placeholder="00:00:00" maxlength="8" class="sgFormTextInput stateValueInput {{'inputMin' + validateNameForCleave(state)}}" [(ngModel)]="state.rawMin" />
                                <input [cleave]="cleaveSettings" placeholder="00:00:00" maxlength="8" class="sgFormTextInput stateValueInput {{'inputMax' + validateNameForCleave(state)}}" [(ngModel)]="state.rawMax" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column -->
                <div class="statesColumn">
                    <div class="agentStateSettingGroup stateinputsTitleGroup" style="margin-bottom: 12px;">
                        <div class="stateInputsGroup">
                            <div class="stateGroupLeft">
                            </div>
                            <div class="stateGroupRight">
                                <div class="stateGroupTitle" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Min">Min</div>
                                <div class="stateGroupTitle" cvLocalizedText langSection="Current_Agent_States_Module" langKey="Max">Max</div>
                            </div>
                        </div>
                    </div>
                    <!-- Right side is populated by those states which belongsRight == true.  Sorts by EState value -->
                    <div class="agentStateSettingGroup" *ngFor="let state of settings.filteredRight; let $index = index">
                        <div class="stateInputsGroup">
                            <div class="stateGroupLeft">
                                <input id="{{moduleKey + '-right-' + $index}}" type="checkbox" class="sgCustomCheckbox" [(ngModel)]="state.enabled " />
                                <div class="colorCircle" [ngStyle]="{ 'background-color': state.Color }"></div>
                                <label for="{{moduleKey + '-right-' + $index}}"  class="stateTitle textTruncate" title="{{ state.StateDisplayName }}">
                                    {{ localizations?.get(state.StateDisplayName) ?? state.StateDisplayName }}
                                </label>
                            </div>
                            <div class="stateGroupRight">
                                <input [cleave]="cleaveSettings" placeholder="00:00:00" maxlength="8" class="sgFormTextInput stateValueInput {{'inputMin' + validateNameForCleave(state)}}" [(ngModel)]="state.rawMin" />
                                <input [cleave]="cleaveSettings" placeholder="00:00:00" maxlength="8" class="sgFormTextInput stateValueInput {{'inputMax' + validateNameForCleave(state)}}" [(ngModel)]="state.rawMax" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>

<!-- CXOne settings-->
<ng-container *ngIf="moduleManager.settingsView === cxOne" >
    <div class="checkboxContainer" [moduleManager]="moduleManager" cvModuleCxoneCustomSettingSection>
        <cxone-checkbox type="checkbox" [labelText]="showLoggedInAgentsText" [(ngModel)]="includeLoggedIn"></cxone-checkbox>
        <cxone-checkbox type="checkbox" [labelText]="showLoggedOutAgentsText" [(ngModel)]="includeLoggedOut"></cxone-checkbox>
    </div>
</ng-container>
